import * as Yup from 'yup';

const fiscalValidationSchema = Yup.object().shape({
  From: Yup.string().required('From is required'),
  To: Yup.string().required('To is required'),
  Type: Yup.string().required('From is required'),
//   Type: Yup.string().required('Type is required'),
});

export default fiscalValidationSchema;